<footer class="bg-[#0d1117] text-[#d7dee4] w-full relative overflow-hidden">

  <!-- top border -->
  <div class="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#3a8fc4] to-transparent"></div>

  <div class="w-full px-4 sm:px-6 lg:px-8 py-6">

    <!-- MAIN -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">

      <!-- Brand -->
      <div>
        <div class="flex items-center gap-3 mb-4">
          <div class="w-9 h-9 rounded-md bg-gradient-to-br from-[#215B81] to-[#2f7ab3] flex items-center justify-center">
            <img src="/images/vfifc-logo.png" class="w-5 h-5" />
          </div>
          <span class="text-lg text-[#e8edf2] tracking-wide">VFIFC</span>
        </div>

        <div class="text-[11px] text-[#215B81] uppercase tracking-[0.18em] mb-3 whitespace-nowrap">
          Victoria Falls International Financial Centre
        </div>

        <p class="text-sm text-white leading-relaxed">
          Trusted partner for company registration, banking solutions, and business growth in Zimbabwe's premier financial hub.
        </p>
      </div>

      <!-- Address -->
      <div>
        <div class="text-[10px] uppercase tracking-[0.2em] text-[#dfe5ea] mb-3 border-b border-[#215B81]/30 pb-2">
          Address
        </div>

        <p class="text-sm text-white leading-relaxed">
          Victoria Falls International<br />
          Financial Centre<br />
          Block D, Ground Floor<br />
          Smatsatsa Office Park, Borrowdale<br />
          Harare, Zimbabwe
        </p>
      </div>

      <!-- Contact -->
      <div>
        <div class="text-[10px] uppercase tracking-[0.2em] text-[#dfe5ea] mb-3 border-b border-[#215B81]/30 pb-2">
          Contact
        </div>

        <a href="tel:+2638612121712" class="block text-sm text-[#c2d4e0] mb-3 hover:text-[#5ab0e0] transition">
          +263 8612 121 712
        </a>
        <a href="mailto:info@vfifc.com" class="block text-sm text-[#c2d4e0] hover:text-[#5ab0e0] transition">
          info&#64;vfifc.com
        </a>
      </div>

    </div>

    <!-- Divider -->
    <div class="flex items-center gap-3 mb-5">
      <div class="flex-1 h-[1px] bg-white/10"></div>
      <div class="w-2 h-2 bg-[#215B81] rotate-45 opacity-70"></div>
      <div class="flex-1 h-[1px] bg-white/10"></div>
    </div>

    <!-- Bottom -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3">

      <p class="text-xs text-[#4e606e] leading-relaxed">
        &copy; {{ year }} VFIFC · All governance documents are confidential and for authorised stakeholders only
      </p>

      <div class="flex gap-2">
        <span class="text-[10px] uppercase tracking-wider text-[#4e606e] border border-white/10 px-2 py-1 rounded">
          Regulated
        </span>
        <span class="text-[10px] uppercase tracking-wider text-[#4e606e] border border-white/10 px-2 py-1 rounded">
          Confidential
        </span>
      </div>

    </div>

  </div>
</footer>